export const ENDERECOCOBRANCA_SET = "deca.ENDERECOCOBRANCA_SET";
export const GET_DADOS_ENDERECO_PRINCIPAL = "deca.GET_DADOS_ENDERECO_PRINCIPAL";
